import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './pages/home/home.component';
import { SharedModule } from '../../shared/shared.module';
import { HeroComponent } from './components/hero/hero.component';
import { CounterupComponent } from './components/counterup/counterup.component';
import { LinewordsComponent } from './components/linewords/linewords.component';
import { CarouselTeamHomeComponent } from './components/carousel-team-home/carousel-team-home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MarqueeComponent } from './components/marquee/marquee.component';
import { CarouselRetalkHomeComponent } from './components/carousel-retalk-home/carousel-retalk-home.component';
import { RouterModule } from '@angular/router';
import { HeroVideoComponent } from './components/hero-video/hero-video.component';



@NgModule({
  declarations: [
    HomeComponent,
    HeroComponent,
    CounterupComponent,
    LinewordsComponent,
    CarouselTeamHomeComponent,
    MarqueeComponent,
    CarouselRetalkHomeComponent,
    HeroVideoComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    SharedModule,
    RouterModule
  ],
  exports: [
    HomeComponent
  ]
})
export class HomeModule { }
